<template>
  <div class="d-flex w-100">
    <div class="d-flex w-100">
      <div class="col-md-3">
        <inqueryDetailsInformationApr ref="detailsInformation" :propApr="propApr"></inqueryDetailsInformationApr>
      </div>
      <div class="col-md-9">
        <inqueryDetailsTableApr ref="registerTable" :propApr="propApr" @editDetails="editDetails"></inqueryDetailsTableApr>
      </div>
    </div>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
// import AprActivitiesRepository from '@/shared/http/repositories/business/aprActivities'
import inqueryDetailsInformationApr from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsInformationApr/inqueryDetailsInformationApr'
import inqueryDetailsTableApr from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/inqueryDetailsTableApr'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'inqueryDetailsapr',
  components: {Multiselect, inqueryDetailsInformationApr, inqueryDetailsTableApr},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      idApr: null,
      propApr: {}
    }
  },
  props: {

  },
  mounted () {
    const params = new URLSearchParams(window.location.search)

    // Log all parameters to the console
    params.forEach((value) => {
      this.idApr = value
      this.getAprSelected(value)
    })
  },
  methods: {
    getAprSelected (value) {
      loading.push()
      AprAnalisePreliminarRisco.GetAprSelected(value)
        .then(Response => {
          this.propApr = Response.data[0]
          loading.pop()
        })
        .catch(err => {
          console.log(err)
          loading.pop()
        })
    },
    editDetails (data) {
      this.getAprSelected(this.idApr)
    }
  }
}

</script>

<style scoped>
.col-md-3{
padding-right: 0;
padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/inqueryDetailsApr.vue